export default __webpack_public_path__ + "static/media/texticon.bfe7b39c.png";